import React from 'react';
import { useLogo } from '../hooks/useLogo';
import { useSelector } from 'react-redux';
import { selectedToggleValue } from '../../../../redux/canvasResolutionSlice';

type LogoContainerProps = { children: React.ReactNode };

const LogoContainer = ({ children }: LogoContainerProps) => {
	const selectedCanvasResolution: any = useSelector(selectedToggleValue);
	const { blockClass } = useLogo();
	const sizeClass = selectedCanvasResolution > 1024 ? 'sizeDesktop' : 'sizeMobile';

	return (
		<span
			className={`logoContainer logoContainer--${blockClass} store-logo vtex-store-components-3-x-logoContainer ${blockClass ? 'vtex-store-components-3-x-logoContainer--' + blockClass : ''} ${sizeClass} vtex-store-components-3-x-${sizeClass} pv4 ph6`}
		>
			{children}
		</span>
	);
};

export default LogoContainer;
